'use client';
/* Built In Imports */
import { useEffect, useState } from 'react';
/* External Imports */
import StructuredTextParser from '@app-ps/Utility/StructuredTextParser';
import { Box, Heading } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

const TopBannerV2 = ({ sectionContent }) => {
  // console.log(sectionContent, 'topbanner');
  const [navigatorObj, setNavigatorObj] = useState(true);
  let iOS = false;
  const bannerTitle = sectionContent?.title.toLowerCase();
  const iPhoneScreenHide = () => {
    var elVideo = document.getElementById('hideiOSVideo');
    iOS = /iPad|iPhone|iPod/.test(navigator?.userAgent) && !window.MSStream;
    // console.log('iOS', iOS, navigator.userAgent);
    setNavigatorObj(navigator.userAgent);
    if (iOS) {
      elVideo.style.display = 'none';
    }
  };
  useEffect(() => {
    iPhoneScreenHide();
  }, []);

  return (
    <Box
      w="full"
      // bg="#fff"
      bg={'black'}
      pb={{ base: '12rem', md: '0' }}
    >
      <Box
        maxW="100%"
        w="100%"
        // 85 vh previous value for base
        h={{ base: '68vh', md: '70vh', lg: '90vh' }}
        maxH={{ lg: '653px', '2xl': '1002px' }}
        bgImg={{
          base: sectionContent?.mobileImage?.url,
          md: sectionContent?.desktopImage?.url,
        }}
        pb={{ md: '2rem' }}
        bgRepeat="no-repeat"
        bgPos={{ base: 'center', md: 'center bottom' }}
        bgSize={{ base: 'cover', md: 'cover' }}
        display="flex"
        flexDirection="column"
        justifyContent="flex-end" // Pushes children to the bottom
        position="relative" // Position relative to contain the absolute gradient
      >
        <Box class="bkg" id="hideiOSVideo">
          <Box
            display={{ base: 'block', md: 'none' }}
            position="absolute"
            top="0"
            bottom="0"
            left="0"
            right="0"
          >
            <video className="vid" autoPlay muted loop>
              {/* mobile video comes here */}
              <source
                src={sectionContent?.mobilevideourl?.trim()}
                type="video/mp4"
              />
            </video>
          </Box>
          <Box
            display={{ base: 'none', md: 'block' }}
            position="absolute"
            top="0"
            bottom="0"
            left="0"
            right="0"
          >
            <video className="vid" autoPlay muted loop>
              {/* desktop video comes here */}

              <source
                src={sectionContent?.desktopvideourl?.trim()}
                type="video/mp4"
              />
            </video>
          </Box>
        </Box>
        {/* Gradient Overlay */}
        <Box
          position="absolute"
          display={{ base: 'block', md: 'block' }}
          bottom="0"
          left="0"
          right="0"
          height={{ base: '30%', md: '50%' }} // Show the gradient for both base and md onwards
          bgGradient={{
            base: 'linear-gradient(180deg, rgba(2, 9, 18, 0) 0%, #020912 100%)',
            md: 'linear-gradient(180deg, rgba(1, 5, 9, 0) 0%, #010509 100%)',
          }}
          zIndex="1" // Ensure gradient is above the background but below the content
        />

        <Box
          display="flex"
          borderWidth={0}
          flexDirection="column"
          gap={{ xl: '0rem', '2xl': '0rem' }}
          justifyContent="center"
          bottom={{ base: '-7rem', md: '0', xl: '0', '2xl': '-3%' }}
          alignItems="center"
          position="relative" // Ensure content is above the gradient
          zIndex="2" // Content should be above the gradient
          mb={{ base: '-5vh', md: '-1vh', lg: '-1vh', xl: '1%', '2xl': '2%' }} // Margin bottom to control position
        >
          <Box
            position="absolute"
            // bottom="0"
            display={{ base: 'block', md: 'none' }}
            zIndex={{ base: '0', lg: '20' }}
            top={{ base: '-90%', lg: '6rem' }}
            left="0"
            right="0"
            height={{ base: '77%', sm: '90%', lg: '100%' }} // Show the gradient for both base and md onwards
            bgGradient={{
              base: 'linear-gradient(180deg, rgba(2, 9, 18, 0) 0%, #020912 100%)',
              md: 'linear-gradient(180deg, rgba(1, 5, 9, 0) 0%, #010509 100%)',
            }}
          />
          <Heading
            zIndex="5"
            as="h1"
            fontSize={{ base: '2.125rem', md: '42px', '2xl': '3.25rem' }}
            fontFamily={'var(--FedraSerifDisplay-Bold)'}
            fontWeight="700"
            position="relative"
            textAlign={{ base: 'center' }}
            lineHeight={{ base: '2.55rem', md: '50px', '2xl': '3.9rem' }}
            letterSpacing={'0.16px'}
            color="#FEFAF6"
            px={{ base: '15px', lg: '0' }}
            textTransform={'capitalize'}
          >
            {bannerTitle}
          </Heading>

          <StructuredTextParser
            css={{
              color: '#DFDFDF', // Default for base
              fontFamily: 'var(--FedraSansStd-book)',
              '@media(min-width: 48em)': {
                // md breakpoint in Chakra UI (768px)
                color: '#FEFAF6',
              },
            }}
            fontSize={{ base: '18px', md: '20px', '2xl': '28px' }}
            lineHeight={{ base: '28.8px', md: '2rem', '2xl': '44.8px' }}
            textAlign={{ base: 'center', sm: 'center', md: 'center' }}
            str={render(sectionContent.quote)}
            mt={{ base: '1rem', '2xl': '1.5rem' }}
          />
        </Box>
      </Box>

      <style>
        {`

          .bkg {
            display: flex;
            align-items: stretch;
            justify-content: center;
            height:100%;
            width: 100%;
            overflow: hidden;
            margin: 0 auto;
          }

          .vid {
            display: block;
            object-fit: cover;
            object-position: top;
            height:100%;
            width: 100%;
          }
          `}
      </style>
    </Box>
  );
};

export default TopBannerV2;
